/* tslint:disable */
/* eslint-disable */
/**
 * Twometerguide API
 * API for the Twometerguide booking module
 *
 * The version of the OpenAPI document: 0.0.1
 * Contact: prot-two-meter-guide@7bits.it
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
/**
 * Условия отмены
 * @export
 * @interface CancellationTermDto
 */
export interface CancellationTermDto {
    /**
     * Дата до которой возможно отмена
     * @type {string}
     * @memberof CancellationTermDto
     */
    beforeDate: string | null;
    /**
     * Дата до которой возможно отмена
     * @type {string}
     * @memberof CancellationTermDto
     */
    afterDate: string | null;
    /**
     * Сумма штрафа
     * @type {number}
     * @memberof CancellationTermDto
     */
    penaltyAmount: number;
    /**
     * Значение штрафа
     * @type {number}
     * @memberof CancellationTermDto
     */
    penaltyValue: number;
    /**
     * Валюта штрафа
     * @type {string}
     * @memberof CancellationTermDto
     */
    penaltyValueCurrency: CancellationTermDtoPenaltyValueCurrencyEnum;
}


/**
 * @export
 */
export const CancellationTermDtoPenaltyValueCurrencyEnum = {
    NoPenalty: 'NO_PENALTY',
    Rub: 'RUB',
    PrepaymentPercent: 'PREPAYMENT_PERCENT',
    Night: 'NIGHT',
    NightPercent: 'NIGHT_PERCENT'
} as const;
export type CancellationTermDtoPenaltyValueCurrencyEnum = typeof CancellationTermDtoPenaltyValueCurrencyEnum[keyof typeof CancellationTermDtoPenaltyValueCurrencyEnum];


/**
 * Check if a given object implements the CancellationTermDto interface.
 */
export function instanceOfCancellationTermDto(value: object): value is CancellationTermDto {
    if (!('beforeDate' in value) || value['beforeDate'] === undefined) return false;
    if (!('afterDate' in value) || value['afterDate'] === undefined) return false;
    if (!('penaltyAmount' in value) || value['penaltyAmount'] === undefined) return false;
    if (!('penaltyValue' in value) || value['penaltyValue'] === undefined) return false;
    if (!('penaltyValueCurrency' in value) || value['penaltyValueCurrency'] === undefined) return false;
    return true;
}

export function CancellationTermDtoFromJSON(json: any): CancellationTermDto {
    return CancellationTermDtoFromJSONTyped(json, false);
}

export function CancellationTermDtoFromJSONTyped(json: any, ignoreDiscriminator: boolean): CancellationTermDto {
    if (json == null) {
        return json;
    }
    return {
        
        'beforeDate': json['beforeDate'],
        'afterDate': json['afterDate'],
        'penaltyAmount': json['penaltyAmount'],
        'penaltyValue': json['penaltyValue'],
        'penaltyValueCurrency': json['penaltyValueCurrency'],
    };
}

  export function CancellationTermDtoToJSON(json: any): CancellationTermDto {
      return CancellationTermDtoToJSONTyped(json, false);
  }

  export function CancellationTermDtoToJSONTyped(value?: CancellationTermDto | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'beforeDate': value['beforeDate'],
        'afterDate': value['afterDate'],
        'penaltyAmount': value['penaltyAmount'],
        'penaltyValue': value['penaltyValue'],
        'penaltyValueCurrency': value['penaltyValueCurrency'],
    };
}

